import React, { useState, useRef, useEffect, forwardRef } from 'react';
import {
  IconButton,
  TextField,
  InputAdornment,
  Container,
  Paper,
  Typography,
  Stack,
  Divider,
  Avatar,
  Box,
  Button,
  Grid,
  Popover,
  makeStyles,
  useMediaQuery,
  Slide,
  Dialog,
} from '@material-ui/core';
import Slider from 'react-slick';
import { REST_API } from 'src/constants/Defaultvalues';
import roundSend from '@iconify/icons-ic/round-send';
import { Icon } from '@iconify/react';
// import Gif from 'src/Gif/chat-ai.gif';
import Lottie from 'lottie-react';
import EveAnimation from 'src/Gif/E V E.json';
import roundAddPhotoAlternate from '@iconify/icons-ic/round-add-photo-alternate';
import EmojiPicker from 'src/components/EmojiPicker';
import { Search, Fullscreen, Minimize, Mic, Close, SentimentDissatisfied } from '@material-ui/icons';
import roundFullscreen from '@iconify/icons-ic/round-fullscreen';
import roundFullscreenExit from '@iconify/icons-ic/round-fullscreen-exit';
import { MIconButton } from 'src/components/@material-extend/index.js';
import axios from 'axios';
import ChatBotEmojiPicker from 'src/components/ChatBotEmojiPicker';
import { COMPANY_LOGO } from "src/constants/Defaultvalues";
import { styled } from '@material-ui/styles';

const Transition = forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

const ChatContainer = ({
  isFullScreen,
  input,
  setInput,
  handleSendMessage,
  handleEnterKeyPress,
  handleFullScreenToggle,
  handleVoiceInput,
  handleEmojiSelect,
  isListening,
  isBotResponding,
  isSpeaking,
  isProfileSectionActive,
  showChat,
  showForm,
  showSearchInput,
  setShowSearchInput,
  isDesktop,
  renderContent,
  isVoiceScreenActive,
  renderVoiceContent
}) => (
  <>
    <Paper sx={{
      pt: !isFullScreen ? 2 : 0, p: isFullScreen ? 1 : 0, width: isFullScreen ? '100vw' : '300px', height: '100%', overflowY: 'auto',
      overflowX: 'hidden',
      '&::-webkit-scrollbar': {
        width: '0.4em',
      },
      '&::-webkit-scrollbar-track': {
        boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
        webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0,0,0,.1)',
        borderRadius: '4px',
      },
    }}>
      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '10px', marginTop: '10px' }}>
          {/* <img
            src={Gif}
            alt="Atom Avatar"
            style={{
              height: '40px',
              width: '40px',
              marginRight: '10px',
            }}
          // onClick={handleToggleTrackOrder}
          /> */}
          <Lottie
            animationData={EveAnimation}
            style={{
              height: '60px',
              width: '60px',
              marginRight: '10px',
            }}
            loop={true}
            autoplay={true}
          />
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant="h6" gutterBottom>
              Atom
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box
                sx={{
                  width: '8px',
                  height: '8px',
                  backgroundColor: 'green',
                  borderRadius: '50%',
                  marginRight: '4px',
                }}
              />
              <Typography variant="caption" color="textSecondary">
                Online
              </Typography>
            </Box>
          </Box>
          <Stack pl={2} style={{ display: showChat && !showForm ? 'flex' : 'none' }}>
            <MIconButton onClick={() => setShowSearchInput(!showSearchInput)}>
              <Search />
            </MIconButton>
          </Stack>


          <Stack pl={2}>
            {isDesktop && (
              <MIconButton onClick={handleFullScreenToggle}>
                <Icon icon={isFullScreen ? roundFullscreenExit : roundFullscreen} width={24} height={24} />
              </MIconButton>
            )}
          </Stack>

        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', mt: -9 }}>
          <IconButton>
            {/* <IconButton onClick={handleToggleForm}> */}
            <Avatar alt="John" sx={{ width: 40, height: 40 }} src={COMPANY_LOGO} />
          </IconButton>
        </Box>
      </Box>

      <Divider sx={{ mb: 3 }} />

      {isVoiceScreenActive ? renderVoiceContent() : renderContent(isFullScreen)}

      <Divider sx={{ mb: 1 }} />

      <Stack direction="row" alignItems="center">
        <TextField
          size="small"
          fullWidth
          id="message"
          placeholder="Write a Message…"
          name="message"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyPress={handleEnterKeyPress}
          sx={{ flex: 1, mb: 1 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {!isProfileSectionActive && (
                  <ChatBotEmojiPicker
                    setValue={setInput}
                    value={input}
                    onSelect={handleEmojiSelect}

                  />
                )}
              </InputAdornment>
            ),
          }}
        />
        <IconButton onClick={handleVoiceInput} sx={{ mb: 1, ml: 1 }} disabled={isBotResponding || isSpeaking}>
          <Mic color={isListening ? 'primary' : (isBotResponding || isSpeaking) ? 'disabled' : 'action'} sx={{ opacity: (isBotResponding || isSpeaking) && 0.4 }} />
        </IconButton>

        <IconButton
          onClick={handleSendMessage}
          sx={{
            mb: 1,
            opacity: input.trim() === '' || isBotResponding ? 0.4 : 1,
            color: input.trim() !== '' ? 'primary.main' : 'inherit'
          }}
          disabled={input.trim() === '' || isBotResponding}
        >
          <Icon icon={roundSend} width={24} height={24} />
        </IconButton>
      </Stack>
    </Paper>

  </>
);

const ChatBot = () => {
  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  const [messages, setMessages] = useState([
    { content: 'Hi there! Atom here, how can I help you?', role: 'assistant' },
  ]);
  const [input, setInput] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const img = '/static/mock-images/avatars/avatar_default1.jpg';
  const [isThinking, setIsThinking] = useState(false);
  const [showChat, setShowChat] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [currentCom, setCurrentCom] = useState('trackOrder');
  const [showTrackOrder, setShowTrackOrder] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const messagesContainerRef = useRef(null);
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const [showSearchInput, setShowSearchInput] = useState(false);
  const [flag, setFlag] = useState('')
  const isDesktop = useMediaQuery('(min-width:571px)');
  const isMobile = useMediaQuery('(max-width: 571px)');
  const [isListening, setIsListening] = useState(false);
  const [isVoiceScreenActive, setIsVoiceScreenActive] = useState(false);
  const [liveTranscript, setLiveTranscript] = useState('');
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [utteranceRef, setUtteranceRef] = useState(null);
  const [speakingContent, setSpeakingContent] = useState('');
  const recognitionRef = useRef(null);
  if (SpeechRecognition) {
    const recognition = new SpeechRecognition();
    recognitionRef.current = recognition;
  } else {
    console.error('SpeechRecognition is not supported in this browser.');
  }
  const [isProfileSectionActive, setIsProfileSectionActive] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [isBotResponding, setIsBotResponding] = useState(false);
  const [isPaused, setIsPaused] = useState(false);

  const handleFullScreenToggle = () => {
    if (isDesktop) {
      setIsFullScreen((prev) => !prev);
      handleClosePopover();
    }
  };

  useEffect(() => {
    // Only send the message to the API if the latest message is from the user
    if (messages.length > 1 && messages[messages.length - 1].role === 'user') {
      handleSendBotMessage();
    }
  }, [flag]);

  // Function to scroll to the bottom of the chat
  const scrollToBottom = () => {
    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
    }
  };

  // Scroll to bottom whenever messages change
  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const [selectedEmoji, setSelectedEmoji] = useState('');

  const handleEmojiSelect = (emoji) => {
    setSelectedEmoji(emoji.native);
  };

  const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: theme.palette.primary.chatbotBack,
      padding: theme.spacing(1),
      borderRadius: 30,
      margin: theme.spacing(2),
    },
    text: {
      color: theme.palette.primary.main,
      fontSize: '1rem',
      fontWeight: 'medium',
    },
  }));

  const classes = useStyles();

  const handleSendBotMessage = async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      const result = await axios.post(REST_API + 'chatbot', {
        prompt: messages,
        user: user,
      });

      if (result) {
        const data = result.data.message;
        const filteredMessages = data.filter((d) => d.role !== 'tool' && d.content !== null);
        const lastUserPrompt = messages[messages.length - 1]?.content;
        setMessages(filteredMessages.filter(msg => msg.role !== 'assistant' || msg.content !== lastUserPrompt));
        setIsThinking(false);

        const botReply = [...filteredMessages].reverse().find((d) => d.role === 'assistant' && d.content);
        if (botReply) {
          speakBotReply(botReply.content);
        }
        if (botReply && isVoiceScreenActive) {
          const utterance = new SpeechSynthesisUtterance(botReply.content);
          utterance.lang = 'en-US';

          const words = botReply.content.split(/\s+/);
          let wordIndex = 0;
          utterance.onboundary = (event) => {
            if (event.name === 'word' && !speechSynthesis.paused) {
              const charIndex = event.charIndex;

              let currentWordIdx = 0;
              let totalChars = 0;

              for (let i = 0; i < words.length; i++) {
                totalChars += words[i].length + 1; // space included
                if (charIndex < totalChars) {
                  currentWordIdx = i;
                  break;
                }
              }

              const highlighted = words.map((w, i) =>
                i === currentWordIdx ? `<span style="color:#1ccaff;font-weight:600">${w}</span>` : w
              ).join(' ');

              setLiveTranscript(highlighted);
            }
          };

          utterance.onend = () => {
            setIsSpeaking(false);
            setLiveTranscript('');
            setIsVoiceScreenActive(false);
          };

          setUtteranceRef(utterance);
          setIsSpeaking(true);
          setSpeakingContent(botReply.content);
          speechSynthesis.cancel();
          speechSynthesis.speak(utterance);
        }
      }
    } catch (error) {
      console.error(error);
      setMessages(prev => [...prev, { content: 'Something went wrong.', role: 'assistant' }]);
      setIsThinking(false);
    } finally {
      setIsThinking(false);
      setIsBotResponding(false); // ✅ Enable buttons again
    }

    setInput('');
    setSearchQuery('');
  };

  const handleVoiceInput = () => {
    if (!SpeechRecognition) {
      console.error('SpeechRecognition is not supported in this browser.');
      return;
    }
  
    const recognition = new SpeechRecognition();
    recognitionRef.current = recognition; // ✅ Important
    recognition.lang = 'en-US';
    recognition.interimResults = true;
    recognition.continuous = true;
  
    setIsListening(true);
  
    if (isVoiceScreenActive) {
      recognitionRef.current?.stop();
      setIsVoiceScreenActive(false);
      setIsListening(false);
      return;
    }
  
    setTimeout(() => {
      setIsVoiceScreenActive(true);
      setIsListening(true);
    }, 100);
  
    setLiveTranscript('');
  
    recognition.onresult = (event) => {
      let finalTranscript = '';
      for (let i = event.resultIndex; i < event.results.length; ++i) {
        const transcript = event.results[i][0].transcript;
        if (event.results[i].isFinal) {
          finalTranscript += transcript + ' ';
          setMessages(prev => [...prev, { content: finalTranscript.trim(), role: 'user' }]);
          setIsThinking(true);
          setIsBotResponding(true);
          setFlag(finalTranscript.trim());
          setLiveTranscript(finalTranscript.trim());
  
          setTimeout(() => {
            recognition.stop();
            setIsVoiceScreenActive(false);
            setIsListening(false);
          }, 2000);
        } else {
          setLiveTranscript(transcript);
        }
      }
    };
  
    recognition.onerror = (e) => {
      console.error("Voice recognition error:", e.error);
      setIsListening(false);
      setIsVoiceScreenActive(false);
      setIsBotResponding(false);
    };
  
    recognition.onend = () => {
      setIsListening(false);
      setIsVoiceScreenActive(false);
    };
  
    recognition.start();
  };  

  useEffect(() => {
    speechSynthesis.onvoiceschanged = () => {
      const voices = speechSynthesis.getVoices();
      const maleVoice = voices.find(v => v.lang === 'en-US' && v.name.toLowerCase().includes('male'));
      localStorage.setItem('preferredVoice', JSON.stringify(maleVoice || voices.find(v => v.lang === 'en-US')));
    };
  }, []);  

  const speakBotReply = (text) => {
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = 'en-US';
  
    const voices = speechSynthesis.getVoices();
    const savedVoice = JSON.parse(localStorage.getItem('preferredVoice'));
    const matchedVoice = voices.find(v => savedVoice && v.name === savedVoice.name);
    utterance.voice = matchedVoice || voices.find(v => v.lang === 'en-US');
  
    const words = text.split(/\s+/);
  
    utterance.onboundary = (event) => {
      if (event.name === 'word' && !speechSynthesis.paused) {
        const charIndex = event.charIndex;
        let currentWordIdx = 0;
        let totalChars = 0;
        for (let i = 0; i < words.length; i++) {
          totalChars += words[i].length + 1;
          if (charIndex < totalChars) {
            currentWordIdx = i;
            break;
          }
        }
        const highlighted = words.map((w, i) =>
          i === currentWordIdx ? `<span style="color:#1ccaff;font-weight:600">${w}</span>` : w
        ).join(' ');
        setLiveTranscript(highlighted);
      }
    };
  
    utterance.onend = () => {
      setIsSpeaking(false);
      setLiveTranscript('');
    };
  
    setUtteranceRef(utterance);
    setIsSpeaking(true);
    setSpeakingContent(text);
    speechSynthesis.cancel();
    speechSynthesis.speak(utterance);
  };  

  const handleSendMessage = async () => {
    // // Stop any ongoing speech before sending a new message
    // if (speechSynthesis.speaking || isSpeaking) {
    //   speechSynthesis.cancel();
    //   setIsSpeaking(false);
    //   setLiveTranscript('');
    // }

    setIsBotResponding(true);

    setCurrentCom('chat');
    setShowChat(true);
    setShowTrackOrder(false);

    const userMessage = { content: input, role: 'user' };
    setMessages((prevMessages) => [...prevMessages, userMessage]);

    const prompt = searchQuery ? `${input} ${searchQuery}` : input;

    // Display "thinking..." message
    setIsThinking(true);
    setFlag(prompt);

    setInput('');
  };

  const handleEnterKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSendMessage();
    }
  };

  const handleToggleChat = () => {
    setCurrentCom('chat')
    setShowChat((prevShowChat) => !prevShowChat);
    setShowTrackOrder(false);

    // Add a predefined message when "Track Your Order" is clicked
    const trackOrderMessage = { content: 'Hey Atom, track my order', role: 'user' };
    setMessages((prevMessages) => [...prevMessages, trackOrderMessage]);

    // Simulate a delay before getting the bot's response
    setIsThinking(true);
    setTimeout(() => {
      // Actual bot response
      const botMessage = { content: 'Sure, send me your order ID ...', role: 'assistant' };
      setMessages((prevMessages) => [...prevMessages, botMessage]);
      setIsThinking(false);
    }, 2000);
  };

  const handleMakeOrder = () => {
    setCurrentCom('chat')
    setShowChat((prevShowChat) => !prevShowChat);
    setShowTrackOrder(false);

    // Add a predefined message when "Track Your Order" is clicked
    const trackOrderMessage = { content: 'Hey Atom, make a new order', role: 'user' };
    setMessages((prevMessages) => [...prevMessages, trackOrderMessage]);

    // Simulate a delay before getting the bot's response
    setIsThinking(true);
    setTimeout(() => {
      // Actual bot response
      const botMessage = { content: 'Sure, i will make new order for you...', role: 'assistant' };
      setMessages((prevMessages) => [...prevMessages, botMessage]);
      setIsThinking(false);
    }, 2000);
  };

  const handleMoreSignboards = () => {
    setCurrentCom('chat')
    setShowChat((prevShowChat) => !prevShowChat);
    setShowTrackOrder(false);

    // Add a predefined message when "Track Your Order" is clicked
    const trackOrderMessage = { content: 'Hear More about signboards', role: 'user' };
    setMessages((prevMessages) => [...prevMessages, trackOrderMessage]);

    // Simulate a delay before getting the bot's response
    setIsThinking(true);
    setTimeout(() => {
      // Actual bot response
      const botMessage = { content: 'Signboards are used for branding for a product some examples given below', role: 'assistant' };
      setMessages((prevMessages) => [...prevMessages, botMessage]);
      setIsThinking(false);
    }, 2000);
  };

  const handleRequestDesign = () => {
    setCurrentCom('chat')
    setShowChat((prevShowChat) => !prevShowChat);
    setShowTrackOrder(false);

    // Add a predefined message when "Track Your Order" is clicked
    const trackOrderMessage = { content: 'Hey Atom, Provide a new design', role: 'user' };
    setMessages((prevMessages) => [...prevMessages, trackOrderMessage]);

    // Simulate a delay before getting the bot's response
    setIsThinking(true);
    setTimeout(() => {
      // Actual bot response
      const botMessage = { content: 'i will approve a new design for you...', role: 'assistant' };
      setMessages((prevMessages) => [...prevMessages, botMessage]);
      setIsThinking(false);
    }, 2000);
  };

  const handleWhyBranding = () => {
    setCurrentCom('chat')
    setShowChat((prevShowChat) => !prevShowChat);
    setShowTrackOrder(false);

    // Add a predefined message when "Track Your Order" is clicked
    const trackOrderMessage = { content: 'Why branding is needed ?', role: 'user' };
    setMessages((prevMessages) => [...prevMessages, trackOrderMessage]);

    // Simulate a delay before getting the bot's response
    setIsThinking(true);
    setTimeout(() => {
      // Actual bot response
      const botMessage = { content: 'Branding is to identify the duplicate products in the market...', role: 'assistant' };
      setMessages((prevMessages) => [...prevMessages, botMessage]);
      setIsThinking(false);
    }, 2000);
  };

  const handleToggleForm = () => {
    if (showForm) {
      setShowChat(currentCom === 'chat' ? true : false);
      setShowTrackOrder(currentCom === 'chat' ? false : true);
    } else {
      setShowChat(false);
      setShowTrackOrder(false);
    }
    setShowForm(!showForm);
    setIsProfileSectionActive(!showForm);
    setShowSearchInput(false); // Add this line to hide search input
  };

  const handleToggleTrackOrder = () => {
    setCurrentCom('trackOrder');
    setShowTrackOrder(true);
    setShowChat(false);
    setShowForm(false);
    setShowSearchInput(false); // Add this line to hide search input
  };

  const handleOpenPopover = (event) => {
    if (anchorEl) {
      setAnchorEl(null); // Close if already open
    } else {
      setAnchorEl(event.currentTarget); // Open if closed
    }
    setShowSearchInput(false); // Add this line to hide search input
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
    setShowSearchInput(false); // Add this line to hide search input
  };

  const openPopover = Boolean(anchorEl);
  const popoverId = openPopover ? 'simple-popover' : undefined;

  const formatMessageText = (content, role, isFullScreen) => {
    const messageStyle = {
      display: 'inline-block',
      padding: '8px 12px',
      borderRadius: '8px',
      backgroundColor: role === 'user' ? '#1ccaff' : '#172e34',
      color: role === 'user' ? 'white' : '#919eab',
      marginBottom: '25px',
      wordWrap: 'break-word',
      maxWidth: isFullScreen ? '90%' : '60%',
    };

    const timestampStyle = {
      fontSize: '0.8rem',
      marginTop: '5px',
      color: role === 'user' ? 'white' : '#919eab',
    };

    const getCurrentTime = () => {
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      const ampm = hours >= 12 ? 'PM' : 'AM';
      const formattedHours = hours % 12 || 12;
      const formattedMinutes = minutes.toString().padStart(2, '0');
      return `${formattedHours}:${formattedMinutes} ${ampm}`;
    };

    // Extract URLs from the message content using the provided regex
    const urls = content.match(urlRegex);

    return (
      <Box sx={{ position: 'relative', textAlign: role === 'user' ? 'right' : 'left' }}>
        {role === 'assistant' && (
          <Lottie
            animationData={EveAnimation}
            style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              height: '30px',
              width: '30px',
            }}
            loop={true}
            autoplay={true}
          />
        )}
        {role === 'user' && (
          <img
            src={COMPANY_LOGO}
            alt="User Avatar"
            style={{
              position: 'absolute',
              bottom: 0,
              right: 0,
              height: '40px',
              width: '40px',
              borderRadius: '50%',
              border: '2px solid #1ccaff',
            }}
          />
        )}
        <Box
          sx={{
            ...messageStyle,
            textAlign: role === 'user' ? 'left' : 'left',
            marginLeft: role === 'assistant' ? '35px' : 0,
            marginRight: role === 'user' ? '50px' : 0,
          }}
        >
          <div>
            {role === 'assistant' && isSpeaking && speakingContent === content && liveTranscript ? (
              <span dangerouslySetInnerHTML={{ __html: liveTranscript }} />
            ) : (
              content.split(urlRegex).map((part, index) => (
                index % 2 === 0 ? (
                  <span key={index}>{part}</span>
                ) : (
                  <a key={index} href={part} target="_blank" rel="noopener noreferrer">{part}</a>
                )
              ))
            )}
          </div>
          <Box width={'100%'} display={'flex'} justifyContent={role === 'user' ? 'flex-end' : 'flex-end'}>
            <div style={timestampStyle}>{getCurrentTime()}</div>
          </Box>
          {role === 'assistant' &&
            !isThinking &&
            content !== 'Hi there! Atom here, how can I help you?' &&
            (speakingContent === content || (!isSpeaking && !speechSynthesis.speaking)) && (
              <Button
                variant="outlined"
                startIcon={
                  <Stack
                    className={isSpeaking ? 'gridicons--pause' : 'fluent--speaker-2-20-filled'}
                    sx={{ color: 'primary.main' }}
                  />
                }
                onClick={() => {
                  if (speechSynthesis.speaking && !speechSynthesis.paused) {
                    speechSynthesis.pause();
                    setIsSpeaking(false);
                    setIsPaused(true); // ✅ Track pause
                  } else if (speechSynthesis.paused) {
                    speechSynthesis.resume();
                    setIsSpeaking(true);
                    setIsPaused(false); // ✅ Track resume
                  } else {
                    speechSynthesis.cancel();
                    setTimeout(() => {
                      const utterance = new SpeechSynthesisUtterance(content);
                      utterance.lang = 'en-US';

                      const words = content.split(/\s+/);

                      utterance.onboundary = (event) => {
                        if (event.name === 'word' && !speechSynthesis.paused) {
                          const charIndex = event.charIndex;
                          let currentWordIdx = 0;
                          let totalChars = 0;
                          for (let i = 0; i < words.length; i++) {
                            totalChars += words[i].length + 1;
                            if (charIndex < totalChars) {
                              currentWordIdx = i;
                              break;
                            }
                          }

                          const highlighted = words.map((w, i) =>
                            i === currentWordIdx ? `<span style="color:#1ccaff;font-weight:600">${w}</span>` : w
                          ).join(' ');
                          setLiveTranscript(highlighted);
                        }
                      };

                      utterance.onend = () => {
                        setIsSpeaking(false);
                        setIsPaused(false); // ✅ Reset pause
                        setLiveTranscript('');
                      };

                      setSpeakingContent(content);
                      setIsSpeaking(true);
                      setIsPaused(false); // ✅ Initial state
                      setUtteranceRef(utterance);
                      speechSynthesis.speak(utterance);
                    }, 100);
                  }
                }}
                sx={{ mt: 1 }}
              >
                {isPaused
                  ? 'Resume'
                  : speechSynthesis.speaking
                    ? 'Pause'
                    : 'Listen'}
              </Button>
            )}
        </Box>
        {role === 'assistant' && urls && urls.length > 0 && (
          <Box
            sx={{
              ...messageStyle,
              textAlign: 'left',
              marginLeft: '35px',
              marginRight: '0',
              minWidth: '70%',
            }}
          >
            <Slider showThumbs={false}>
              {urls.map((url, index) => (
                <div
                  key={index}
                  style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                >
                  <img
                    style={{ height: '180px', width: '200px' }}
                    src={url}
                    alt={`Bot Image ${index + 1}`}
                  />
                </div>
              ))}
            </Slider>
            <Box width={'100%'} display={'flex'} justifyContent={role === 'user' ? 'flex-start' : 'flex-end'}>
              <div style={timestampStyle}>{getCurrentTime()}</div>
            </Box>
          </Box>
        )}
      </Box>
    );
  };

  const renderVoiceContent = () => (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        height: '100vh',
        maxHeight: '100vh',
        background: 'linear-gradient(135deg, #02001f, #1ccaff)',
        zIndex: 2000,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        px: 3,
      }}
    >

      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: -1,
          overflow: 'hidden',
          filter: 'blur(12px)',
          opacity: 0.8,
        }}
      >
        <svg
          viewBox="0 0 3600 200"
          preserveAspectRatio="none"
          style={{
            width: '300%',
            height: '100%',
            animation: 'moveWave 10s linear infinite',
          }}
        >
          <path
            d="M0,100 C300,50 600,150 900,100 C1200,50 1500,150 1800,100 C2100,50 2400,150 2700,100 C3000,50 3300,150 3600,100"
            fill="none"
            stroke="#1ccaff"
            strokeWidth="4"
          />
        </svg>
      </Box>

      <Typography variant="h1" sx={{ mb: 2, fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>
        Atom AI Voice <span style={{ fontWeight: 'bold', color: '#1ccaff' }}>Assistant</span>
      </Typography>

      <Typography variant="h3" sx={{ mb: 5, textAlign: 'center' }}>
        {liveTranscript.split(' ').map((word, index, arr) => (
          <span
            key={index}
            style={{
              color: index === arr.length - 1 ? '#1ccaff' : '#fff',
              fontWeight: index === arr.length - 1 ? 600 : 400,
            }}
          >
            {word}{' '}
          </span>
        ))}
      </Typography>

      <Box
        className="mic-outer-circle"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '50%',
          p: 3,
          mb: 4,
          background: 'radial-gradient(circle at center, #1ccaff 40%)',
          animation: 'pulse-ring 2s infinite',
        }}
      >
        <IconButton
          onClick={() => {
            setIsVoiceScreenActive(false);
            setIsListening(false);
            recognitionRef.current?.stop();
          }}
          sx={{
            backgroundColor: 'transparent',
            color: '#fff',
            width: 80,
            height: 80,
          }}
        >
          <Mic sx={{ fontSize: 40 }} />
        </IconButton>
      </Box>
    </Box>
  );

  const renderContent = (isFullScreen) => {
    // Filter messages based on the search query
    const filteredMessages = messages.filter((message) =>
      message.content.toLowerCase().includes(searchQuery.toLowerCase())
    );
    return (
      <>

        {showSearchInput && (
          <TextField
            size="small"
            id="search"
            placeholder="Search chats..."
            name="search"
            sx={{ flex: 1, mb: 2, mt: -1, width: '100%', pl: isFullScreen ? 4 : 0, pr: isFullScreen ? 3 : 0, }}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        )}
        {/* //ChatSection */}
        {showChat && <Paper
          ref={messagesContainerRef} // Attach the ref to the Paper element
          sx={{
            mb: 5,
            height: isFullScreen ? { sm: '80vh', md: '80vh', lg: '68vh', xl: '79vh' } : '300px',
            overflowY: 'auto',
            overflowX: 'hidden',
            '&::-webkit-scrollbar': {
              width: '0.4em',
            },
            '&::-webkit-scrollbar-track': {
              boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
              webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: 'rgba(0,0,0,.1)',
              borderRadius: '4px',
            },
          }}
        >
          {filteredMessages.length === 0 && showSearchInput && (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: 200,
                animation: 'fadeIn 0.5s ease-in-out',
              }}
            >
              <SentimentDissatisfied sx={{ fontSize: 60, color: '#1ccaff', mb: 1 }} />
              <Typography variant="h6" sx={{ color: 'text.secondary', textAlign: 'center' }}>
                No search results found for your query.
              </Typography>
            </Box>
          )}
          {filteredMessages.map((message, index) => (
            <Box key={index} sx={{ textAlign: message.role === 'user' ? 'right' : 'left' }}>
              {formatMessageText(message.content, message.role, isFullScreen)}
            </Box>
          ))}
          {isThinking && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, pl: 2, pt: 1, pb: 1 }}>
              {[...Array(4)].map((_, i) => (
                <Box
                  key={i}
                  sx={{
                    width: 4,
                    height: 10,
                    background: '#1ccaff',
                    borderRadius: 2,
                    animation: `barAnim 1s ease-in-out ${i * 0.1}s infinite`,
                  }}
                />
              ))}
              <Typography variant="body2" sx={{ ml: 0.5, color: '#1ccaff' }}>
                Analyzing ...
              </Typography>
            </Box>
          )}
          {isListening && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, pl: 2, pt: 1, pb: 1 }}>
              {[...Array(4)].map((_, i) => (
                <Box
                  key={i}
                  sx={{
                    width: 4,
                    height: 10,
                    background: '#1ccaff',
                    borderRadius: 2,
                    animation: `barAnim 1s ease-in-out ${i * 0.1}s infinite`,
                  }}
                />
              ))}
              <Typography variant="body2" sx={{ ml: 0.5, color: '#1ccaff' }}>
                Listening ...
              </Typography>
            </Box>
            /* <Box sx={{ textAlign: 'left' }}>{formatMessageText('Listening...', 'assistant')}</Box> */
            /* <img src="/static/icons/voice-wave.gif" alt="Listening..." width="80" /> */
          )}
        </Paper>}
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: -3 }}>
          {/* //FirstSection */}
          {showTrackOrder && <Grid sx={{ height: '300px', width: '300px' }}>
            <Paper className={classes.root} onClick={handleToggleChat}>
              <Typography className={classes.text} variant="body2" align="center">
                {showTrackOrder ? 'Track Your Order' : 'Track Your Order'}
              </Typography>
            </Paper>

            <Paper className={classes.root} onClick={handleMoreSignboards}>
              <Typography className={classes.text} variant="body2" align="center">
                {showTrackOrder ? 'Hear More About Signboards' : 'Hear More About Signboards'}
              </Typography>
            </Paper>

            <Paper className={classes.root} onClick={handleRequestDesign}>
              <Typography className={classes.text} variant="body2" align="center">
                {showTrackOrder ? 'Request For A New Design' : 'Request For A New Design'}
              </Typography>
            </Paper>

            <Paper className={classes.root} onClick={handleWhyBranding}>
              <Typography className={classes.text} variant="body2" align="center">
                {showTrackOrder ? 'Why Branding Is Needed' : 'Why Branding Is Needed'}
              </Typography>
            </Paper>
          </Grid>}
        </Box>
        {/* //ProfileSection */}
        {showForm && <Grid container spacing={2} sx={{ height: '300px', p: 2 }}>
          <Grid item xs={6}>
            <TextField label="First Name" fullWidth />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Last Name" fullWidth />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Phone" fullWidth />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Email" fullWidth />
          </Grid>
          <Grid item xs={12} sx={{ mb: 3, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
            <Button variant="outlined" color="primary" onClick={handleToggleForm}>
              Cancel
            </Button>
            <Button variant="contained" color="primary" onClick={handleToggleForm}>
              Save
            </Button>
          </Grid>
        </Grid>}
      </>
    )
  }

  useEffect(() => {
    return () => {
      speechSynthesis.cancel();
      setIsSpeaking(false);
      setLiveTranscript('');
    };
  }, []);

  return (
    <>
      <MIconButton onClick={handleOpenPopover} sx={{ padding: 0, width: 44, height: 44, top: 3 }}>
        <Lottie
          animationData={EveAnimation}
          style={{
            width: '50px',
            height: '50px',
          }}
          loop={true}
          autoplay={true}
        />
      </MIconButton>
      <Popover
        id={popoverId}
        open={openPopover}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      // sx={{mt:-7}}
      >
        <Container component="main" maxWidth='xs'>
          <ChatContainer
            isFullScreen={isFullScreen}
            input={input}
            setInput={setInput}
            handleSendMessage={handleSendMessage}
            handleEnterKeyPress={handleEnterKeyPress}
            handleFullScreenToggle={handleFullScreenToggle}
            handleVoiceInput={handleVoiceInput}
            handleEmojiSelect={handleEmojiSelect}
            isListening={isListening}
            isBotResponding={isBotResponding}
            isSpeaking={isSpeaking}
            isProfileSectionActive={isProfileSectionActive}
            showChat={showChat}
            showForm={showForm}
            showSearchInput={showSearchInput}
            setShowSearchInput={setShowSearchInput}
            isDesktop={isDesktop}
            renderContent={renderContent}
            isVoiceScreenActive={isVoiceScreenActive}
            renderVoiceContent={renderVoiceContent}
          />
        </Container>
      </Popover>

      <Dialog fullScreen open={isFullScreen} onClose={() => setIsFullScreen(false)} TransitionComponent={Transition}>
        <ChatContainer
          isFullScreen={isFullScreen}
          input={input}
          setInput={setInput}
          handleSendMessage={handleSendMessage}
          handleEnterKeyPress={handleEnterKeyPress}
          handleFullScreenToggle={handleFullScreenToggle}
          handleVoiceInput={handleVoiceInput}
          handleEmojiSelect={handleEmojiSelect}
          isListening={isListening}
          isBotResponding={isBotResponding}
          isSpeaking={isSpeaking}
          isProfileSectionActive={isProfileSectionActive}
          showChat={showChat}
          showForm={showForm}
          showSearchInput={showSearchInput}
          setShowSearchInput={setShowSearchInput}
          isDesktop={isDesktop}
          renderContent={renderContent}
          isVoiceScreenActive={isVoiceScreenActive}
          renderVoiceContent={renderVoiceContent}
        />
      </Dialog>
    </>
  );
};

export default ChatBot;